

<div class="login-wrapper">
    <div class="login-form">
        <ngt-button (click)="authService.login()">{{('login' | translate)()}}</ngt-button>
      <!-- <div>{{versionInfo}}</div>
      <div>{{versionMessage}}</div> -->
    </div>
  </div>
